import { LOCALES } from "../locales";

export default {
  [LOCALES.ENGLISH]: {
    // general product translation
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December",
    class_policy: "Class Policy",
    Faq: "FAQs",
    help: "Help",
    category: "Category",
    frequently_asked_ques: "Frequently Asked Questions",
    customer_support: "Customer Support",
    user_name: "User name",
    password: "Password",
    email_address: "Email address",
    // Header Translations
    notification: "Notification",
    page_loading_aria: "Page is loading",
    state_loading_aria: "State is loading",
    city_loading_aria: "City is loading",
    badge_placeholder: "Badge placeholder",
    badge_overall: "Overall badge",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "Certificate image",
    certificate_download: "Download certificate button",
    prev: "Previous",
    log_out: "Log out",
    //navbar
    navbar_course: "Course",
    navbar_tools: "Tools",
    navbar_skill_index: "Skill Index",
    navbar_level_index: "Level Index",
    navbar_schedule: "Schedule",
    // feature names
    feature_progress: "Progress",
    feature_stressAndIntonation_title: "Stress and intonation",
    feature_soundOfEnglish_title: "Sounds of english",
    feature_vocabularyCenter_title: "Vocabulary center",
    feature_grammarCenter_title: "Grammar center",
    feature_culture_centre_title: "Culture center",
    feature_globalCommunityTutorials_title: "Global community tutorials",
    feature_industryfeed_title: "Industry feed",
    feature_newsfeed_title: "News feed",
    feature_emailTemplates_title: "Email templates",
    feature_talkWithTeacher_title: "Talk with the teacher",
    feature_accentsAndDialects_title: "Accents and dialects",
    feature_writingCenter_title: "Writing center",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "About",
    legal: "Legal",
    privacy_policy: "Privacy policy",
    Terms_conditions: "Terms of Use",
    //button translations
    button_continue: "Continue",
    button_KnowMore: "Know more",
    button_BuyNow: "Buy Now",
    button_Subscribe: "Subscribe",
    button_GetStarted: "Get started",
    button_GetResult: "Get results",
    button_GetLoading: "Loading...",
    button_view: "View",
    button_GoText: "Go",
    button_Resume: "Continue learning",
    button_ViewDetails: "View details",
    button_ContinueStudying: "Continue",
    button_next: "Next",
    button_confirm: "Confirm",
    // cookie policy
    common_cookiesPolicyText1:
      "By continuing to use this site, you agree to the use of cookies to provide you with better services. Read our",
    common_cookiesPolicyText2: "cookies policy",
    // EO cookie policy
    //login-page-translations//
    login_welcome: "Welcome",
    login_heloo: "Hello again",
    login_welcome_text: "Let's get started.",
    login_log_in: "Log in",
    login_errorIncorrectCreds: "Username or password incorrect.",
    login_errorContactAmin: "Your account is not active. Contact your administrator.",
    login_errorSSOuser: "You must log in from your company's learning portal.",
    login_forgotPassword: "Forgotten password?",
    login_resetPasswordTitle: "Reset password",
    login_resetSuccess: "We’ve sent you an email containing a link that will allow you to reset your password.",
    login_resetFailure: "Email address is incorrect.",
    // common translations
    message_errorDefault: "Something went wrong",
    message_successUpdated: "Updated successfully",
    message_unknownError: "Unknown error",
    message_unAuthorized: "You are not authorized to access this page.",
    message_passwordUpdated: "Password updated successfully",
    message_profileUpdated: "Profile updated successfully",
    message_welcomeSubmitted: "Submitted successfully",
    message_samepasswordError: "Enter a new password, please make sure its not a previously used one.",
    SAR: "Select a region",
    SAL: "Select a location",
    SAT: "Select a topic",
    SAA: "Select a language",
    link_readmore: "Read more",
    //--//
    profile_title: "Profile",
    profile_nameLabel: "My name is: ",
    profile_countryLabel: "Country",
    profile_stateLabel: "State / Province / Region",
    profile_cityLabel: "City",
    profile_emailLabel: "Email",
    profile_prefContactLabel: "Preferred contact",
    profile_prefSkypeLabel: "Skype (Personal) ID",
    profile_prefMobileLabel: "Mobile number",
    profile_prefLandlineLabel: "Landline number",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "I accept and agree to the Terms and Conditions.",
    profile_continueAria: "Continue button",
    profile_TermsAria: "Accept Terms and Conditions",
    profile_stateTooltip: "Your timezone will help us schedule your online sessions.",
    profile_cityTooltip: "If you dont live in one of the cities shown here, please pick the closest one to you.",
    profile_emailTooltip: "Verify your email.",
    profile_prefTooltip:
      "All your sessions will take place in the virtual classroom, even if you specified a different contact method in the on-boarding process. We ask you about your preferred contact method for internal use only so that we can continually improve your learning experience.",
    profile_fnamePlaceholder: "First name",
    profile_lnamePlaceholder: "Last name",
    profile_countryPlaceholder: "Select a country",
    profile_prefContactSelect: "Select your preference",
    profile_statePlaceholder: "Select a state",
    profile_cityPlaceholder: "Select a city",
    profile_emailInvalidMessage: "Email address is invalid",
    profile_prefContactPlaceholder: "Choose your preference",
    profile_prefSkypePlaceholder: "Skype (Personal)",
    profile_emailVerifiedChip: "Verified",
    profile_emailVerifyChip: "Verify",
    profile_emailpopup_head: "Enter verification code",
    profile_emailpopup_resendText: "Resend code",
    profile_emailpopup_resendMessage: "Didn't receive the code?",
    profile_invalidNumber: "Invalid number",
    profile_prefSkypeAria: "Preferred Contact as Skype (Personal) ID",
    profile_prefMobileAria: "Preferred Contact as Mobile",
    profile_prefLandlineAria: "Preferred Contact as Landline",
    profile_emailpopup_incorrectCode: "Invalid code",
    profile_editLabel: "Edit profile",
    profile_editAria: "Edit button",
    profile_mainPasswordPlaceholder: "Enter password here",
    profile_updateLabel: "Update",
    profile_welcomeJumbotron: "Tell us about yourself",
    profile_cancelLabel: "Cancel",
    noAccessl1: "Oops! You don't have permission to view this page!",
    noAccessl2: "Here's a link back to the",
    noAccessl2_1: "homepage",
    noAccessl3: "Please contact your Learnship Administrator for help.",
    license_information: "License information",
    profile_license_information: "License information",
    profile_license_message: "Your license expires on",
    profile_changepass_changepassHead: "Change password",
    profile_changepass_currentpassword: "Current password *",
    profile_changepass_currentpasswordPlaceholder: "Enter current password",
    profile_changepass_newpassword: "New password *",
    profile_changepass_newpasswordPlaceholder: "Enter new password",
    profile_changepass_confirmnewpassword: "Confirm new password *",
    profile_passMustInclude: "Your password must include:",
    profile_passdontmatch: "Passwords don't match",
    profile_incorrectPassword: "Incorrect current password",
    profile_passwordSubmit_title: "Enter password",
    profile_changepass_conditionLength: "Between 8 to 32 characters.",
    profile_changepass_conditionUppercase: "At least one uppercase letter.",
    profile_changepass_conditionLowercase: "At least one lowercase letter.",
    profile_changepass_conditionSpecialCharacters: "At least one numeric digit and one of these symbols $!#&@?%*_",
    profile_translationLanguage: "Translation language",
    profile_translationLanguagePlaceholder: "Choose a language",
    profile_managerEmailPlaceholder: "Manager's email",
    profile_managerEmailpopupPlaceholder: "Manager's email address",
    // Learner Home Page translations
    learnerhome_survey_header: "We need your feedback!",
    learnerhome_survey_line1: "Your company wants to know about your experience using our service.",
    learnerhome_survey_line2: "Please complete our survey by",
    learnerhome_survey_line3: "Your feedback is very important and greatly appreciated.",
    learnerhome_survey_button1: "Take survey",
    learnerhome_survey_button2: "Skip survey",
    active_course: "Active course",
    admin_header: "Administration",
    admin_dashboard_header: "Dashboard",
    product_learnship_dashboard:
      "This is your gateway to Dashboard - an intuitive interface that allows administrators to track usage, analyse learner progress, optimize programs and evaluate ROI.",
    get_startedText: "Click on a course below to get started.",
    product_solo_desc:
      "Learnship Solo, our e-learning product, provides everything learners need to practice and improve their business language skills at their own pace.",
    product_baseline_step:
      "Test your grammar and listening skills online with Baseline Step, Learnship’s 30-min English proficiency assessment.",
    product_baseline_step_plus:
      "Test your grammar, reading, listening, and speaking skills online with Baseline Step+, Learnship’s 52-min English proficiency assessment.",
    product_solo_premium:
      "Your digital language learning program. Learn Business English at your own pace – with the mentoring of a learning specialist, and regular group sessions to improve your conversation skills with the guidance of an expert trainer.",
    product_conversationPractice_desc:
      "Learners can book one-on-one sessions with trainers to ask questions, discuss a particular issue or role play scenarios. Useful for more experienced learners looking to finesse their skills.",
    product_sprint_businessSkills_desc:
      "This next-generation blended learning program helps learners develop specific business skills— presenting, negotiating, business writing and meeting participation— in record time.",
    product_sprint_levelsProgress_desc:
      "Our next-generation blended language program helps your people rapidly improve their English language skills against a standardized framework.",
    product_sprint_business_german_desc:
      "Your fast-paced language learning program. Scale up your Business German proficiency within weeks, practicing with an expert trainer.",
    product_sprint_business_french_desc:
      "Your fast-paced language learning program. Scale up your Business French proficiency within weeks, practicing with an expert trainer.",
    product_sprint_business_spanish_desc:
      "Your fast-paced language learning program. Scale up your Business Spanish proficiency within weeks, practicing with an expert trainer.",
    product_sprint_business_skills_groups_desc:
      "This next-generation blended learning program helps learners develop specific business skills— in groups—in record time.",
    product_evolve_relocationLanguage_desc:
      "Our employee relocation program helps learners develop a deeper understanding of the language and social nuances of their new country of residence.",
    product_evolve_culturePowerSkills_desc:
      "Give your employees the cross-cultural skills they need to thrive in international working environments and global virtual teams.",
    product_evolve_cultureFocus_desc:
      "Country-specific training and cultural-intelligence for learners who need to gain a better understanding of a specific region and its working culture.",
    product_evolve_cultureChange_desc:
      "This is our premier intercultural business training program for expats. It gives learners an in-depth understanding of what it takes to live and work in a new culture.",
    product_elevate_businessSkills_desc:
      "Short, standardized training modules for language learners who want to improve specific business skills such as presenting, negotiating or team leadership. We also offer specialist courses focused on industry-specific dialects.",
    product_elevate_levelsProgress_desc:
      "This trainer-led business language course helps learners improve their written and verbal skills against a standardized framework.",
    product_coach_languageCoach_desc:
      "Communicate confidently and clearly in boardrooms, emails, negotiations and even around the watercooler. Our one-on-one, hyper-specific executive language coaching helps you master the most important business scenarios. Develop your verbal, written, meeting and personal communication skills.",
    product_coach_cultureCoach_desc:
      "A hyper-focused, one-on-one coaching program for executives looking to solve specific cross-cultural communication problems.",
    product_solo_business_english:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business English at your own pace.",
    product_solo_business_german:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business German at your own pace.",
    product_solo_business_french:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business French at your own pace.",
    product_solo_business_spanish:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business Spanish at your own pace.",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc:
      "This is your gateway to Dashboard - an intuitive interface that allows administrators to track usage, analyze learner progress, optimize programs and evaluate ROI.",
    product_elevate_desc:
      "Elevate Business English is our online, face-to-face language training for learners who want to improve their overall language proficiency working with a personal trainer.",
    product_reach_desc:
      "Enhance your learning journey with personalized micro-modules and side missions focusing on real-world business skills.",
    product_lorem_solo_desc:
      "This rich multimedia program helps your people rapidly improve their English language skills against a standardized framework.",
    //feature translations
    feature_cultureCentre_desc:
      "Familiarize yourself with the cultures of the regions that are important to your business and professional life.",
    feature_emailTemplates_desc:
      "Email templates cover a wide variety of business topics. Select the template you want and export it directly to your email client where you can edit it.",
    feature_newsFeed_desc:
      "Welcome to witness a news reading and English learning experience where content and questions are generated live, which gives you access to world news and helps you to enhance your English.",
    feature_talkWithTeacher_desc:
      "This is for learners who want to apply their new skills in conversation. Users can join a virtual group classroom to practice their chosen language and take part in Q&As with speaking speacialists.",
    feature_industryFeed_desc:
      "The Industry Feed combines a library of industry-specific articles with AI-powered language exercises. Choose an article along with a grammar point you want to practice…",
    feature_accentsAndDialects_desc:
      "Explore the richness of global English usage through our library of regional speech samples.",
    feature_stressAndIntonation_desc:
      "Make your English more natural and easier to understand by learning how to use correct stress, rhythm, and intonation when you speak.",
    feature_soundOfEnglish_desc:
      "Improve your communication skills by learning how to pronounce English sounds correctly.",
    feature_vocabularyCenter_desc:
      "Without grammar, very little can be conveyed. Without vocabulary, nothing can be conveyed. - David Wilkins",
    feature_grammarCenter_desc:
      "The Grammar Center will help you use correct grammar in your speaking and writing. It includes grammar topics, such as basic sentence parts, verbs and verb forms, and sentences and clauses.",
    feature_globalCommunityTutorials_desc:
      "Improve your English language skills with this growing collection of community-developed lessons.",
    feature_toeic_desc:
      "The TOEIC® test is the instrument most widely used by multinational corporations to measure employees’ English proficiency. The TOEIC® uses authentic written materials and dialogue to assess your business English skills.",
    feature_toefl_desc:
      "TOEFL®, the Test of English as a Foreign Language, is used worldwide by colleges and universities, government agencies, and scholarship programs to evaluate English proficiency.",
    feature_businessSituations_desc:
      "The Business Situations Index makes it easy for you to find specific activities so that you can focus on the language you need to communicate in a variety of business situations.",
    //carousel block translations
    title_feature: "Features",
    we_recommend: "We also recommend",
    // session report translations
    SessionReport_sessionReport: "Session report",
    SessionReport_sessionDetails: "Details",
    SessionReport_teacherName: "Teacher name",
    SessionReport_sessionReview: "Session review",
    SessionReport_sessionFeedback: "Session feedback",
    SessionReport_sessionMaterials_Assignments: "Session Materials & Assignments",
    SessionReport_instructions: "Instructions",
    SessionReport_open: "Open",
    SessionReport_invalidSession_Message: "Sorry, there is no report for this session.",
    SessionReport_rateSession: "Rate your session",
    SessionReport_handouts: "Handouts",
    SessionReport_coachName: "How was your session with",
    SessionRating_sessionDate: "Session date",
    SessionRating_sessionTime: "Session time",
    SessionRating_sessionDuration: "Session duration",
    SessionRating_status: "Status",
    SessionRating_rateYourExperience: "Rate your experience",
    SessionRating_whatWentWrong: "What went wrong?",
    SessionRating_content: "Content",
    SessionRating_technology: "Technology",
    SessionRating_comment: "Leave a comment",
    SessionRating_submit: "Submit",
    SessionRating_remindMeLater: "Remind me later",
    SessionRating_close: "Close",
    SessionRating_completed: "Finished",
    sessionRating_sessionDetails_mins: "Minutes",
    // my schedule page translations
    myschedule_availability_abty_given: "We are working hard to match you with a trainer",
    myschedule_schedule: "My schedule",
    myschedule_availability_needAvl: "We need your availability to schedule your session",
    myschedule_availability_abty_not_given: "Provide / Modify your availability.",
    myschedule_statusCard_completed: "Session(s) completed",
    myschedule_statusCard_remaining: "Session(s) remaining",
    myschedule_statusCard_scheduled: "Session(s) to be scheduled",
    myschedule_nocourse_card_description: "Your course is not yet created",
    myschedule_nocourse_card_availability: "We need your availability to schedule your session",
    myschedule_statusCard_lost: "Lost (Late cancelled and absent)",
    myschedule_recentUpcoming_courseName: "Course name",
    myschedule_next_session: "Next session",
    myschedule_session_topic: "Session topic",
    myschedule_sessionDetails_communication: "Communication",
    myschedule_sessionDetails_allSessions: "All sessions",
    myschedule_sessionDetails_upcomingSessions: "Upcoming sessions",
    myschedule_sessionDetails_completedSessions: "Completed sessions",
    myschedule_sessionDetails_missedSessions: "Missed sessions",
    myschedule_sessionDetails_teacher_name: "Teacher",
    myschedule_sessionDetails_sessions: "Number",
    myschedule_sessionDetails_dateTime: "Date / Time",
    myschedule_sessionDetails_date: "Date",
    myschedule_sessionDetails_time: "Time",
    myschedule_sessionDetails_durationText: "Duration",
    myschedule_sessionDetails_min: "Min",
    myschedule_reschedule_Title: "How to reschedule your session",
    myschedule_reschedule_InstrBegin: "Here's how you can reschedule your sessions with your trainer:",
    myschedule_reschedule_instr1a: "Check session details at the top.",
    myschedule_reschedule_instr1b: "The date and time of your session are shown at the top.",
    myschedule_reschedule_instr2: "Trainer’s availability is displayed in green.",
    myschedule_reschedule_instr3:
      "You will be able to see your trainer's availability. Available time slots are in green.",
    myschedule_reschedule_instr4: "Select a slot to reschedule.",
    myschedule_reschedule_instr5:
      "To reschedule, click into the green area of available time slots for your chosen time.",
    myschedule_reschedule_next_instr1: "No suitable time slot.",
    myschedule_reschedule_next_instr2:
      "Try to avoid cancellations, if you really cannot find a suitable time with your trainer, use the 'NO SUITABLE TIME SLOT' button to cancel your session. In this case your trainer will schedule this session for you or an administrator will assist you.",
    myschedule_reschedule_next_instr3: "Change your trainer",
    myschedule_reschedule_next_instr4a:
      "To change your trainer for one or more of your remaining sessions please use our",
    myschedule_reschedule_next_instr4b: "Contact form",
    myschedule_reschedule_next_instr4c:
      "and select {productname} + 'Change Trainer'.Please provide a reason why you would like to change your trainer.",
    myschedule_rechedule_next_info:
      "For further information regarding the rescheduling and cancellation options of trainer please visit our",
    myschedule_rechedule_next_faq: "FAQ portal.",
    myschedule_rechedule_next_noShow: "Don't show this info page again.",
    myschedule_rechedule_next_done: "Done",
    myschedule_rechedule_skipButton: "Skip",
    myschedule_upcoming_joinNow: "Join now",
    myschedule_cancel_question: "Are you sure you want to cancel this session?",
    myschedule_cancel_button: "Cancel Session",
    myschedule_cancel_no: "No",
    myschedule_invalid_session: "There are no sessions for this course.",
    myschedule_sessionDuraion_minutes: "Minutes",
    myschedule_homepage_view: "View",
    myschedule_reschedule_button: "Reschedule",
    myschedule_addToCalendar_instr1: "Click on the",
    myschedule_addToCalendar_instr2:
      "download button to get your Learnship schedule. You can then add it to your personal calendar.",
    myschedule_addToCalendar_instr3:
      "If you have previously added a Learnship schedule to your calendar, please make sure to delete the existing one first.",
    myschedule_addToCalendar_instr4: "Learn more about how to add the Learnship schedule to your personal calendar",
    myschedule_addToCalendar_instr5: "here.",
    myschedule_no_teacher_title: "Teacher not assigned",
    myschedule_no_teacher_body:
      "No Sessions can be added at the moment (No teachers assigned). Please contact coach@globalenglish.com to continue with your program.",
    myschedule_no_all_sessions: "No sessions found",
    myschedule_no_upcoming_sessions: "No upcoming sessions found",
    myschedule_no_missed_sessions: "No missed sessions found",
    myschedule_no_completed_sessions: "No completed sessions found",
    myschedule_status_lost: "Lost",
    myschedule_status_finished: "Finished",
    myschedule_status_completed: "Completed",
    myschedule_status_cancelled: "Cancelled",
    myschedule_status_inprogress: "In progress",
    myschedule_status_pending: "Pending",
    myschedule_status_active: "Active",
    myschedule_status_inplanning: "In planning",

    // my schedule page translations end
    // Progress page
    progress_title: "My Progress",
    progress_activity_report: "Activity report",
    progress_test_results: "Test results",
    progress_productname_sprint_skills: "Sprint Business Skills",
    progress_productname_reach_skills: "Reach Skills",
    progress_skill_note:
      "You must complete 70% or more of the coursework and sessions to be eligible for a certificate of completion.",
    progress_overall_card_title_prework: "Pre-work completed",
    progress_overall_card_title_homework: "Homework completed",
    progress_overall_card_title_session: "Session completed",
    progress_overall_card_title_certificate: "Certificate",
    progress_overall_card_title_skillsCompleted: "Skills completed",
    progress_overall_card_title_badgesEarned: "Badges earned",
    progress_overall_card_title_missionsPassed: "Missions passed",
    progress_overall_card_title_timeInReach: "Time in Reach (HH:MM)",
    progress_noSubskill: "There is no subskill to show.",
    progress_activityreport_nodata: "Currently, there is no data to show here. Keep learning and come back later",
    progress_tab_nodata: "No data to show here.",
    progress_tab_notonboarded: "Complete your onboarding to access your reports",
    progress_percentCompleted: "percent completed",
    progress_subskill_preworkTitle: "Pre-Work",
    progress_subskill_homeworkTitle: "Homework",
    progress_subskill_sessionTitle: "Session",
    progress_subskill_sessionStatusCompleted: "Completed",
    progress_subskill_sessionStatusNotCompleted: "Not completed",
    progress_subskill_sessionStatusAbsent: "Absent",
    progress_subskill_sessionStatusUpcoming: "Upcoming",
    progress_subskill_sessionStatusScheduled: "Scheduled",
    progress_subskill_sessionStatusScheduling: "Scheduling",
    progress_subskill_sessionStatusNoSessions: "No sessions",
    progress_subskill_sessionNoDate: "N/A",
    progress_activity_tooltip_totaltime: "Total time",
    progress_activity_tooltip_activitiesCompleted: "Activities completed",
    progress_activity_tooltip_reachMissionsCompleted: "Reach missions completed",
    progress_activity_tooltip_timeinhhmm: "Time in HH:MM",
    progress_activity_tabDaily: "Daily",
    progress_activity_tabWeekly: "Weekly",
    progress_activity_tabMonthly: "Monthly",
    progress_activity_tabQuarterly: "Quarterly",
    progress_activity_tabQuarter: "Quarter",
    progress_activity_tabYearly: "Yearly",
    progress_acitivity_Minutes: "Minutes",
    progress_acitivity_legend_selfpaced: "Self paced learning time",
    progress_acitivity_legend_trainerLed: "Trainer led time",
    progress_acitivity_legend_recommended: "Recommended",
    progress_testresults_table_testname: "Test name",
    progress_testresults_table_scores: "Scores",
    progress_testresults_table_date: "Date",
    progress_testresults_info: "Your tests results will appear in 24 hours.",
    progress_testresults_placed_text: "Placed",
    progress_test_result_timer_text: "*Your test results will appear in 24 hours.",
    progress_inprogress: "In progress",
    progress_totalscore: "Total score",
    progress_placedText: "Placed",
    progress_button_viewscore: "View detailed report.",
    progress_certificate_download_success: "Downloaded successfully",
    progress_partText: "Part",
    progress_emptyPartText: "Other",
    progress_overall_card_title_badge: "Badge",
    progress_total_correctness_percentage: "Your success score is: ",
    progress_badge_dialog_box_title:
      "In order to earn a certificate of completion, we require completion of 70% of the digital exercises.",
    progress_badge_dialog_box_golden: "A success score of 80% earns a gold badge.",
    progress_badge_dialog_box_silver: "A success score between 70% and 79% earns a silver badge.",
    progress_badge_dialog_box_bronze: "A success score between 50% to 69% earns a bronze badge.",
    progerss_badge_dailog_box_digitalActivities:
      "The success score is calculated based on your performance and engagement with the online digital activities.",
    progress_badge_dailog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with the online digital activities and live sessions.",
    progress_elevate_dialog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with live sessions",
    //EO Progress page
    // Email templates start
    wcTitle: "Writing Center",
    guidelines: "Writing Guidelines",
    sampleDocs: "Sample Documents",
    languageSelect: "Select a language",
    wcGroup1: "Apologies",
    wcGroup2: "Complaints",
    wcGroup3: "Compliments",
    wcGroup4: "Congratulations",
    wcGroup5: "Documents",
    wcGroup6: "Invitations",
    wcGroup7: "Job Applications",
    wcGroup8: "Marketing and Sales",
    wcGroup9: "Meetings",
    wcGroup10: "Notices",
    wcGroup11: "Orders",
    wcGroup12: "Pricing Information",
    wcGroup13: "Requests",
    wcGroup14: "Thank You",
    wcTitle11: "Apology for a Delay in a Project",
    wcTitle12: "Apology for an Account Error",
    wcTitle13: "Apology for a Late Shipment",
    wcTitle14: "Apology for Delivery of Damaged Goods",
    wcTitle15: "Apology for Missing a Meeting",
    wcTitle21: "General Complaint",
    wcTitle22: "Complaint about a Problem with a Product",
    wcTitle23: "Complaint about an Overcharge to an Account",
    wcTitle31: "Compliment to a Colleague on a Project",
    wcTitle32: "Compliment about Customer Service",
    wcTitle33: "Compliment about a Product",
    wcTitle41: "Congratulations on a Promotion (Formal)",
    wcTitle42: "Congratulations on a Promotion (Informal)",
    wcTitle43: "Congratulations on a Personal Event",
    wcTitle51: "Requested Document",
    wcTitle52: "Order Form or Purchase Order",
    wcTitle53: "Invoice",
    wcTitle61: "Invitation to a Social Event",
    wcTitle62: "Invitation to a Business Event",
    wcTitle63: "Accepting an Invitation",
    wcTitle64: "Declining an Invitation",
    wcTitle65: "Canceling a Business Event",
    wcTitle71: "Acknowledgement of Receipt of Application",
    wcTitle81: "Announcement of a New Product",
    wcTitle82: "Announcement of a New Area Representative",
    wcTitle83: "New Product Demo",
    wcTitle84: "Change of Billing Address",
    wcTitle85: "Follow-Up after a First Sales Meeting",
    wcTitle86: "New Customer Welcome",
    wcTitle87: "Holiday Message to Stockholders or Customers",
    wcTitle91: "Proposing a Time for a Meeting",
    wcTitle92: "Confirming a Meeting",
    wcTitle93: "Postponing a Meeting",
    wcTitle94: "Canceling a Meeting",
    wcTitle95: "Summarizing a Meeting",
    wcTitle101: "Suspended Account",
    wcTitle102: "Request to Close an Account",
    wcTitle111: "Confirming an Order",
    wcTitle112: "Providing Shipping Confirmation",
    wcTitle113: "Canceling an Order",
    wcTitle114: "Changing an Order",
    wcTitle115: "Acknowledging a Delivery",
    wcTitle121: "Providing Pricing Information",
    wcTitle122: "Accepting a Price Quotation",
    wcTitle123: "Rejecting a Price Quotation",
    wcTitle131: "Request for Clarification of Information",
    wcTitle132: "Request for Information about a Product",
    wcTitle133: "Request for Information about a Service",
    wcTitle141: "General Thanks",
    guideGroup1: "Common Writing Problems",
    guideGroup2: "General Business Communication",
    guideGroup3: "Business Documents",
    guideTitle11: "Reasons for Unclear Writing",
    guideTitle12: "Basic Writing Errors",
    guideTitle13: "Problems with Verbs",
    guideTitle21: "Directness in Business Communication",
    guideTitle22: "Language for Sales and Marketing",
    guideTitle23: "Everyday Business Idioms",
    guideTitle31: "Effective Emails",
    guideTitle32: "Presentations: General Tips",
    guideTitle33: "Presentations: Effective Openings",
    backIndex: "Back to Index",
    copyText: "Copy Text",
    exportEmail: "Export Text to Email",
    Blob: "Email templates cover a wide variety of business topics. Select the template you want and export it directly to your email client where you can edit it.",
    OpenInEmail: "Open in email",
    Quote1: "There are currently 3.3 billion email accounts in the world.",
    Quote1By: "Mashable",
    Quote2: "Email generates nearly a 2X return compared to other channels.",
    Quote2By: "Direct Marketing Lead",
    Quote3: "3.5 million emails are sent per second.",
    Quote3By: "Marketing Lead",
    SelectACategory: "Select a category",
    WatchTutorial: "Watch a video tutorial",
    String: "Quote1",
    NoAm: "North America",
    Cenam: "Central America",
    SoAm: "South America",
    EUR: "Europe",
    ASIA: "Asia",
    CenASIA: "Central Asia",
    SoEASIA: "South East Asia",
    MidEAST: "Middle East",
    AFR: "Africa",
    AUST: "Australia",
    Cana: "Canada",
    Mexi: "Mexico",
    Uniteds: "United States",
    CostaR: "Costa Rica",
    DomRep: "Dominican Republic",
    Guate: "Guatemala",
    Jama: "Jamaica",
    Panam: "Panama",
    TriniTob: "Trinidad & Tobago",
    Arge: "Argentina",
    Braz: "Brazil",
    Chil: "Chile",
    Vene: "Venezuela",
    Colomb: "Colombia",
    Peru: "Peru",
    Urug: "Uruguay",
    Austria: "Austria",
    Belg: "Belgium",
    Bulg: "Bulgaria",
    Croatia: "Croatia",
    Czec: "Czech Republic",
    Denm: "Denmark",
    Finl: "Finland",
    Fran: "France",
    Germ: "Germany",
    Greec: "Greece",
    Hung: "Hungary",
    Icel: "Iceland",
    Irel: "Ireland",
    Ital: "Italy",
    Lith: "Lithuania",
    Luxem: "Luxembourg",
    Neth: "Netherlands",
    Norw: "Norway",
    Pola: "Poland",
    Port: "Portugal",
    Roma: "Romania",
    Russ: "Russian Federation",
    Serb: "Serbia",
    Slovakia: "Slovakia",
    Slovania: "Slovenia",
    Spai: "Spain",
    Swed: "Sweden",
    Swit: "Switzerland",
    Turk: "Turkey",
    Ukra: "Ukraine",
    Unitedk: "United Kingdom",
    Chin: "China",
    Hong: "Hong Kong",
    Indi: "India",
    Japa: "Japan",
    Mongo: "Mongolia",
    Pakis: "Pakistan",
    SoKore: "South Korea",
    SriLan: "Sri Lanka",
    Taiw: "Taiwan",
    Afgh: "Afghanistan",
    Azer: "Azerbaijan",
    Kaza: "Kazakhstan",
    Camb: "Cambodia",
    Indo: "Indonesia",
    Malay: "Malaysia",
    Phil: "Philippines",
    Sing: "Singapore",
    Thai: "Thailand",
    Viet: "Vietnam",
    Bah: "Bahrain",
    Iran: "Iran",
    Iraq: "Iraq",
    Isra: "Israel",
    Jor: "Jordan",
    Kuw: "Kuwait",
    Leb: "Lebanon",
    Oma: "Oman",
    Qat: "Qatar",
    SauArb: "Saudi Arabia",
    UAE: "United Arab Emirates",
    Alger: "Algeria",
    Angol: "Angola",
    Egyp: "Egypt",
    Ghana: "Ghana",
    Guin: "Guinea",
    Keny: "Kenya",
    Malaw: "Malawi",
    Moroc: "Morocco",
    Mozam: "Mozambique",
    Nige: "Nigeria",
    SoAfr: "South Africa",
    Tanz: "Tanzania",
    Ugan: "Uganda",
    Zamb: "Zambia",
    Austra: "Australia",
    NewZea: "New Zealand",
    culturenotes_mainintrotext:
      "Familiarize yourself with the cultures of the regions that are important to your business and professional life.",
    culturenotes_useculturalinfo:
      "Use our cultural information to prepare for important meetings with customers and coworkers around the world.",
    culturenotes_topicfamiliarize:
      "Familiarize yourself with customs, such as business hours, dining out, gift giving, etc. in other cultures.",
    culturenotes_topiclearnculture:
      "Learn about cultural practices, cultural differences, and local manners to avoid making cultural mistakes.",
    culturenotes_tmaworldtext:
      "Country reports are developed by our partner TMA World and are available in downloadable PDF versions.",
    culturenoteslocation_viewbytopic: "View by topic",
    culturenoteslocation_viewbycountry: "View by country",
    culurecenter_disclaimer_title: "Disclaimer",
    culturecenter_disclaimer:
      "Please treat the information you are going to read as a general guide, which is meant to be a starting point for familiarizing yourself with a new culture. This tool will help you learn about common cultural patterns, which will serve you as a framework for better understanding and interpreting cultural differences in people’s behavior, attitudes and reactions. However, it is important to bear in mind that common characteristics of a particular culture vary regionally and by individual personality.",
    culturecenter_intercept_title: "Culture center is back!​​",
    culturecenter_intercept_text1: "After a little brush up, we’re glad to announce that Culture Center is back!",
    culturecenter_intercept_text2:
      "With Culture Center, you get to learn more about the professional practices and customs in 20 countries around the world, including the USA, Canada, Mexico, China, Japan, India, and many more...​",
    culturecenter_intercept_direct: "Go to culture center​",
    dailyNewsFeed_resources: "Resources",
    dailyNewsFeed_daily_News: "Daily news feed",
    dailyNewsFeed_newsfeedoftheday: "News feed of the day",
    dailyNewsFeed_feedcontent:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData: "Sorry, we are unable to fetch your daily news feed, please try again after sometime.",
    dailyNewsFeed_viewMoreCategories: "View more categories",
    // Email templates end
    //Error Page Translations
    error_not_found: "Oops! Page not found.",
    error_contact_csm: "Please contact your Customer Success Manager for help.",
    error_under: "Under",
    error_maintenance: "maintenance",
    error_under_maintenance: "Our site is currently undergoing scheduled maintenance.",
    error_inconvenience: "We're sorry for any inconvenience.",
    error_tryagain: "Please try again later.",
    error_tryagainMins: "Please try again in",
    error_minutes: "minute(s).",
    error_hours: "hour(s)",
    error_oops: "Oops!",
    error_permission_denied: "You don't have permission to view this page!",
    error_link_home: "home page",
    error_contact_admin: "Please contact your Learnship Administrator for help.",
    error_sorry: "We're sorry.",
    error_load: "There was a problem loading this page.",
    error_clear_cache: "Please clear your browser's cache, check your internet connection, and try again.",
    error_contact: "Please contact our",
    error_contact_cst: "Customer Support team",
    error_forhelp: "for help.",
    error_having_trouble: "Still having trouble?",
    //Accents and Dialects Dropdowns
    AF: "Africa",
    AS: "Asia",
    AU: "Australia-Oceania",
    CA: "Caribbean",
    CE: "Central America",
    EU: "Europe",
    MI: "Middle East",
    NO: "North America",
    SO: "South America",
    CAMER: "Cameroon",
    EGYPT: "Egypt",
    ETHIO: "Ethiopia",
    GHANA: "Ghana",
    GUINE: "Guinea",
    NIGER: "Nigeria",
    SOUTH: "South Africa",
    TANZA: "Tanzania",
    AFGHA: "Afghanistan",
    CHINA: "China",
    INDIA: "India",
    INDON: "Indonesia",
    JAPAN: "Japan",
    KAZAK: "Kazakhstan",
    LEBAN: "Lebanon",
    MONGO: "Mongolia",
    NORTH: "North Vietnam",
    PAKIS: "Pakistan",
    PHILI: "Philippines",
    SINGA: "Singapore",
    KOREA: "South Korea",
    SRI_L: "Sri Lanka",
    TAIWA: "Taiwan",
    THAIL: "Thailand",
    TURKM: "Turkmenistan",
    AUSTR: "Australia",
    FIJI_: "Fiji",
    NEW_Z: "New Zealand",
    BERMU: "Bermuda",
    CUBA_: "Cuba",
    HAITI: "Haiti",
    COSTA: "Costa Rica",
    GUATE: "Guatemala",
    MARTI: "Martinique (French)",
    TRINI: "Trinidad and Tobago",
    AUSTRI: "Austria",
    BELAR: "Belarus",
    BELGI: "Belgium",
    BULGA: "Bulgaria",
    CYPRU: "Cyprus",
    CZECH: "Czech Republic",
    DENMA: "Denmark",
    ENGLA: "England",
    FINLA: "Finland",
    FRANC: "France",
    GEORG: "Georgia",
    GERMA: "Germany",
    GREEC: "Greece-Hellas",
    HUNGA: "Hungary",
    IRELA: "Ireland",
    ITALY: "Italy",
    MACED: "Macedonia",
    NETHE: "Netherlands",
    NORTHI: "Northern Ireland",
    POLAN: "Poland",
    ROMAN: "Romania",
    RUSSI: "Russian Federation",
    SCOTL: "Scotland",
    SPAIN: "Spain",
    SWEDE: "Sweden",
    SWITZ: "Switzerland",
    TURKE: "Turkey",
    UKRAI: "Ukraine",
    WALES: "Wales",
    IRAN_: "Iran",
    IRAQ_: "Iraq",
    ISRAE: "Israel",
    KUWAI: "Kuwait",
    SAUDI: "Saudi Arabia",
    SYRIA: "Syria",
    CANAD: "Canada",
    MEXIC: "Mexico",
    ARGEN: "Argentina",
    BRAZI: "Brazil",
    CHILE: "Chile",
    COLOM: "Colombia",
    PARAG: "Paraguay",
    PERU_: "Peru",
    VENEZ: "Venezuela",
    RPTitle: "Rainbow passage",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "Accents and dialects",
    US: "United States of America",
    ALABA: "Alabama",
    ALASK: "Alaska",
    ARKAN: "Arkansas",
    CALIF: "California",
    FLORI: "Florida",
    GEORG_US: "Georgia",
    HAWAI: "Hawaii",
    ILLIN: "Illinois",
    INDIA_US: "Indiana",
    KANSA: "Kansas",
    KENTU: "Kentucky",
    LOUIS: "Louisiana",
    MAINE: "Maine",
    MARYL: "Maryland",
    MASSA: "Massachusetts",
    MICHI: "Michigan",
    MINNE: "Minnesota",
    MISSI: "Mississippi",
    MISSO: "Missouri",
    MONTA: "Montana",
    NEBRA: "Nebraska",
    NEW_H: "New Hampshire",
    NEW_J: "New Jersey",
    NEW_Y: "New York",
    NCARO: "North Carolina",
    NDAKO: "North Dakota",
    OHIO_: "Ohio",
    OKLAH: "Oklahoma",
    PENNS: "Pennsylvania",
    SOUTH_US: "South Carolina",
    TENNE: "Tennessee",
    TEXAS: "Texas",
    VIRGI: "Virginia",
    WEST_: "West Virginia",
    WISCO: "Wisconsin",
    manager_email_managertext:
      "Your company has requested a monthly report for your manager indicating your progress in Learnship. Please provide your manager’s email address below.",
    // survey and notification
    notification_description_plural: "{days} days remaining to complete the survey. You must complete it by {date}.",
    notification_description_singular: "1 day remaining to complete the survey. You must complete it by {date}.",
    notification_maintenance_message: "Halo will be undergoing scheduled maintenance on {date} at {time}.",
    renewal_welcome: "Welcome back to Learnship!",
    renewal_text:
      "Your Learnship license will expire on {date}, {month} {year}. To continue improving your Business English Communication skills, renew your license today. Your study plan and all of your work will be saved and you will continue at your current level.",
    renewal_later: "Please ask me later",
    renewal_affirmative: "I want to renew my license.",
    renewal_negative: "I do not want to renew my license.",
    renewal_yes: "YES",
    renewal_no: "NO",
    courselevel: "Course level",
    currentunit: "Current unit",
    upcomingsession: "Upcoming session",
    viewschedule: "View Schedule",
    currentskills: "Skills",
    currentsubskills: "Sub-skills",

    // TWT translations
    twt_talk_with_teacher_title: "Talk with the Teacher",
    twt_sub_heading: "Practice your conversation skills with a teacher and other learners in our online classroom!",
    twt_select_sessions: "Select your sessions",
    twt_view_schedule_title: "View schedule and add to calendar",
    twt_next_week: "Next week",
    twt_previous_week: "Previous week",
    twt_add_to_calendar: "Add to calendar",
    twt_view_more: "View more",
    twt_topic: "Topic",
    twt_class_policy_title: "Talk with the Teacher (TWT) Policies and Guidelines",
    twt_class_policy_subHeading:
      "The following policies and guidelines are important for ensuring that your experience with Talk with the Teacher is educational and enjoyable. Please read them carefully.",
    twt_class_policy_list01:
      "You may attend one class per week. Our online classrooms have a limit of eight students. For the best chance of getting a place in an online classroom, you must arrive near the beginning of the class session. Talk with the Teacher classrooms are available only during the first 10 minutes of each class. For example, a class that begins at 9:00 is available until 9:10. After the first 10 minutes, you will not be able to join the class.",
    twt_class_policy_list02_sub1:
      "When you enter the classroom, type your name, city, country, and level in the Chat box.",
    twt_class_policy_list02_sub2: "My name is Leo, and I'm from Sao Paulo, Brazil. I'm in Level 6.",
    twt_class_policy_list02_sub3:
      "The instructor will then activate your microphone and the microphone icon will appear.",
    twt_class_policy_list03:
      "If you have a technical problem, contact Customer Support. Click Help at the top of any page. Please do not ask the instructor for technical help.",
    twt_class_policy_list04:
      "Watch the Talk with the Teacher Orientation before entering the online classroom. This orientation will give you valuable information about participating in the online class.",
    twt_class_policy_list05:
      "There are four Talk with the Teacher class levels: Beginner, Intermediate, Advanced, and All Levels. You must go to a class that is appropriate for your English ability. For example, if you are in Levels 0 - 3, you must go to a beginner Talk with the Teacher class. All students may attend the All Levels classes. If you join a Talk with the Teacher class that is not appropriate for your English ability, your instructor will inform you that you are not in the correct class and your class session will end.",
    twt_class_policy_list06:
      "If you would like to listen to an online class without speaking, you may do so for one hour per week. After that, you must participate by speaking during class. You may listen without speaking for a total of four classes per year. If you go over these limits and do not begin to participate in the class, your class session will end.",
    twt_class_policy_ok: "Ok",
    twt_max_multi_window_error_message:
      "You have already joined this session from another device. Please logout before joining from current device.",
    twt_max_capacity_error_message:
      "Sorry you cannot join this session because it has reached maximum capacity. Please join another session.",
    twt_notification_message: "There's a conversation session starting right now. Do you want to join?",
    twt_limit_message: "You have already taken one class this week.",
    twt_session_unavailable: "No sessions available",
    twt_select_language: "Select language",

    //IDLE Timer
    session_expiring: "Session Expiring",
    timer_title_1: "Your session is about to time out.",
    timer_title_2: "To continue studying, click Ok.",
    ok_timer: "Ok",
    //Vocabulary center translations
    search:"Search",
    vocab_center_product_headline: "Vocabulary center",
    vocab_center_search_word: "Search and add word",
    vocab_center_add_wordlist: "Add word list",
    vocab_center_edit_wordlist: "Edit word list",
    vocab_center_delete_wordlist: "Delete word list",
    vocab_center_options_text: "Options",
    vocab_center_add_word: "Add word",
    vocab_center_add_text: "Add",
    vocab_center_delete_wordlist_warning_message: "All the words under the list will be deleted. Click Yes to delete.",
    vocab_center_yes_text: "Yes",
    vocab_center_new_wordlist: "New word list",
    vocab_center_created_wordlist_success_message: "You have successfully created your new word list.",
    vocab_center_updated_wordlist_success_message: "You have successfully updated your word list.",
    vocab_center_okay_text: "Okay",
    vocab_center_new_word_text: "New word",
    vocab_center_enter_word_text: "Enter a word",
    vocab_center_wordlist_exists: "This wordlist already exists.",
    vocab_center_word_exists_in_wordlist_warning_message: "This word already exists in this Word List.",
    vocab_center_save_text: "Save",
    vocab_center_new_word_message: "This word is not currently in our wordlist. Do you want to add it to the wordlist?",
    vocab_center_pos_label: "Part of speech",
    vocab_center_select_wordlist_text: "Select a word list",
    vocab_center_word_label: "Word",
    vocab_center_update_wordlist: "Update word list",
    vocab_center_definition_label: "Definition",
    vocab_center_translation_label: "Translation",
    vocab_center_sentence_label: "Sentence",
    vocab_center_note_label: "Note",
    vocab_center_cancel_text: "Cancel",
    vocab_center_delete_word_text: "Delete word",
    vocab_center_delete_word_warning_message: "Are you sure you want to delete this word from the Word List?",
    vocab_center_note_updated_message: "Your notes updated successfully!!",
    vocab_center_close_text: "Close",
    vocab_center_no_definition_text: "No definition available",
    vocab_center_no_translation_text: "No translation available",
    vocab_center_no_sentence_text: "No sentence available",
    vocab_center_no_note_text: "No notes added",
    vocab_center_word_save_message: "You have successfully saved the word in your word List.",
    vocab_center_word_exists_error_message: "The selected word already exists in the same wordlist.",
    vocab_center_submit_text: "Submit",
    vocab_center_delete_text: "Delete",
    vocab_center_edit_text: "Edit",
    vocab_center_print_text: "Print",
    vocab_center_no_word_message: "Oops! There are no words in your wordlist. Add new words!",
    vocab_center_no_wordlist_message: "Oops! There are no wordslist in {wordListName}. Add new wordslist!",
    vocab_center_enter_wordlist_text: "Enter a word list",
    vocab_center_feature_text:
      "Without grammar, Very little can be conveyed. Without vocabulary, nothing can be conveyed. - David Wilkins",
    vocab_center_feature_summary:
      "Explore and expand your lexicon effortlessly with the Vocabulary Center, your gateway to discovering and mastering new words seamlessly",
    // Stress and inotation translations
    stress_intonation_product_headline: "Stress and Intonation",
    stress_intonation_product_description:
      "Make your English more natural and easier to understand by learning how to use correct stress, rhythm, and intonation when you speak.",
    // Sounds of English translations
    soe_product_headline: "Sounds of English",
    soe_product_description: "Improve your communication skills by learning how to pronounce English sounds correctly.",
    soe_product_vowels: "Vowels",
    soe_product_consonants: "Consonants",
    soe_product_language_selection:
      "Select your language in the drop-down list to find the sounds that may be difficult for speakers of your language. Then select My Sounds to find the sounds that you had trouble with in the Pronunciation Practice and Communication Practice activities.",
    // Writing center
    wc_feature_headline: "Writing center",
    wc_feature_description: "Level up your professional writing ability via our targeted resources.",
    wc_feature_guideGroup1: "Common Writing Problems",
    wc_feature_guideGroup2: "General Business Communication",
    wc_feature_guideGroup3: "Business Documents",
    wc_feature_guideTitle11: "Reasons for Unclear Writing",
    wc_feature_guideTitle12: "Basic Writing Errors",
    wc_feature_guideTitle13: "Problems with Verbs",
    wc_feature_guideTitle21: "Directness in Business Communication",
    wc_feature_guideTitle22: "Language for Sales and Marketing",
    wc_feature_guideTitle23: "Everyday Business Idioms",
    wc_feature_guideTitle31: "Effective Emails",
    wc_feature_guideTitle32: "Presentations: General Tips",
    wc_feature_guideTitle33: "Presentations: Effective Openings",
    // sso leaner intercept
    learners_intercept_title: "Important Notice",
    learners_intercept_text1:
      "The way you log on to Learnship is changing! Citi has partnered with Learnship to enable Single Sign On access for all global learners. As of 9:00am CEST on November 18, 2022, you will be required to go to ",
    learners_intercept_text2: "It is important to note that you will no longer be able to log-on via\u202f",
    learners_intercept_text3: "Please take note of this change and bookmark the new page. ",
    learners_intercept_text4: "For support, please reach out to your local HR contact or\u202f",
    // google learner intercept
    google_intercept_title: "Important Notice",
    google_intercept_subtitle: "The way you log on to Learnship is changing! ",
    google_intercept_text1: "Google has partnered with Learnship to enable ",
    google_intercept_text2: "for all learners. ",
    google_intercept_text3: "Effective from ",
    google_intercept_text4: "you will be required to go to ",
    google_intercept_text5: "It is important to note that, from ",
    google_intercept_text6: ", you will no longer be able to access your Learnship course through ",
    google_intercept_text7:
      "Please make a note of the above change and remember to delete any old bookmarks and replace it with the new link.",
    google_intercept_text8: "For support, please reach out to ",
    google_sso_text: " Single Sign On (SSO) ",
    google_dd_mmm_text: "18th May",
    google_intercept_time: "10:00am CEST",
    google_intercept_date: "18 May 2023",
    google_intercept_on_text: "on",
    google_link_not_work: "This link will not work before that date.",
    learnship_note_google: "Note: ",
    learnship_family_note_google:
      "This change only applies to Googlers. Family members will continue to log in as before.",
    // nestle learner intercept
    nestle_intercept_title: "Important Notice",
    nestle_intercept_subtitle: "The way you log on to Learnship is changing! ",
    nestle_intercept_text1: "Nestlé has partnered with Learnship to enable ",
    nestle_intercept_text2: "for all learners in Switzerland. ",
    nestle_intercept_text3: "Effective from ",
    nestle_intercept_text4: "you will be required to go to ",
    nestle_intercept_text5: "It is important to note that, from ",
    nestle_intercept_text6: ", you will no longer be able to access your Learnship course through ",
    nestle_intercept_text7:
      "Please make a note of the above change and remember to delete any old bookmarks and replace it with the new link.",
    nestle_intercept_text8: "For support, please reach out to your ",
    nestle_service_desk: "Nestlé ServiceDesk",
    nestle_dd_mmm_text: "4th May",
    nestle_sso_text: " Single Sign On (SSO) ",
    nestle_intercept_time: "10:00am CEST",
    nestle_intercept_date: "4th May 2023",
    nestle_intercept_on_text: "on",
    nestle_intercept_or_text: "or ",
    nestle_link_not_work: "This link will not work before that date.",
    learnship_note_nestle: "Note: ",
    learnship_family_note_nestle:
      "This change only applies to Nestlé employees. Family members will continue to log in as before.",
    welcome_Contact_number_helper_text:"To ensure prompt assistance and personalized support, we highly recommend providing your contact number as well"
  },
};
